export default __webpack_public_path__ + "static/media/careteam_my_tickets_instruction.e6287d10.svg";